import { cn } from '@ui/atoms/utils/utils';
import React from 'react';

const ListingWrapper = ({
    children,
    className,
    wrapperClassName,
    tag: Tag = 'div',
    ...props
}) => {
    return (
        <Tag className={cn('w-full', className)} {...props}>
            <div
                className={cn(
                    'max-w-[1184px] mx-auto w-full',
                    wrapperClassName
                )}
            >
                {children}
            </div>
        </Tag>
    );
};

export default ListingWrapper;
